import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-termination',
  templateUrl: './org-termination.component.html',
  styleUrls: ['./org-termination.component.css']
})
export class OrgTerminationComponent implements OnInit {

  displayDialog: boolean;

  constructor() { }

  ngOnInit() {
  }
  closeDialog() {
    this.displayDialog = false;
  }
  saveTerminationDetails() {
    console.log("saving termination details");
  }
}
